import { useState } from "react";
import { HelpCircle, Menu, X } from "lucide-react";
import { GlobalSearch } from "@/components/GlobalSearch";
import { HelpPanel } from "@/components/HelpPanel";
import { NotificationBell } from "@/components/NotificationBell";
import { UserMenu } from "@/components/UserMenu";
import { toggleMobileNav, useMobileNavOpen } from "@/lib/mobileNav";

export default function AppHeader() {
  const navOpen = useMobileNavOpen();
  const [helpOpen, setHelpOpen] = useState(false);
  return (
    <header className="app-header" data-testid="app-header">
      <button
        className="mobile-menu-button"
        type="button"
        aria-label={navOpen ? "Close navigation" : "Open navigation"}
        aria-expanded={navOpen}
        aria-controls="mobile-navigation"
        data-testid="mobile-menu-button"
        onClick={toggleMobileNav}
      >
        {navOpen ? <X size={20} aria-hidden="true" /> : <Menu size={20} aria-hidden="true" />}
      </button>
      <GlobalSearch />
      <div className="header-actions">
        <button
          className="icon-button"
          type="button"
          aria-label="Help center"
          aria-expanded={helpOpen}
          data-testid="help-center-button"
          onClick={() => setHelpOpen(true)}
        >
          <HelpCircle size={19} />
        </button>
        <NotificationBell />
        <div className="header-divider" />
        <UserMenu />
      </div>
      <HelpPanel open={helpOpen} onClose={() => setHelpOpen(false)} />
    </header>
  );
}
